import Group from 'components/utils/Group'
import type { ComponentProps } from 'react'
import React from 'react'
import styled from 'styled-components'
import PriceRowLuxPlusMemberPrice from './LuxPlus/PriceRowLuxPlusMemberPrice'
import PriceRowPrice from './PriceRowPrice'

const Stack = styled(Group)`
  &.h-align-start {
    text-align: start;
  }
  &.h-align-center {
    text-align: center;
  }
  &.h-align-end {
    text-align: end;
  }
`

type InheritedPriceRowPriceProps = Pick<ComponentProps<typeof PriceRowPrice>, 'saleUnit' | 'size' | 'signDisplay'>

interface Props extends InheritedPriceRowPriceProps {
  memberPrice: number
  nonMemberPrice: ComponentProps<typeof PriceRowPrice>['price']
  /**
   * @default start
   */
  horizontalAlign?: 'start' | 'center' | 'end'
  desktopHorizontalAlign?: 'start' | 'center' | 'end'
  testid?: string
}

/**
 * Displays the regular (non-member) price prominently as a large heading,
 * with the LuxPlus member price shown as a secondary caption below.
 *
 * Mirrors the visual hierarchy of PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice
 * but with positions swapped: regular price on top, LP+ price on bottom.
 */
function PriceStackPriceWithLoyaltyLeadWithRegularPrice(props: Props) {
  const {
    memberPrice,
    nonMemberPrice,
    saleUnit,
    size,
    horizontalAlign = 'start',
    desktopHorizontalAlign,
    signDisplay,
    ...rest
  } = props

  return <Stack
    {...rest}
    className={`h-align-${horizontalAlign}`}
    direction="vertical"
    horizontalAlign={horizontalAlign}
    gap={2}
    desktopHorizontalAlign={desktopHorizontalAlign}
  >
    <PriceRowPrice
      size={size}
      price={nonMemberPrice}
      saleUnit={saleUnit}
      signDisplay={signDisplay}
    />
    <PriceRowLuxPlusMemberPrice
      memberPrice={memberPrice}
      saleUnit={saleUnit}
      signDisplay={signDisplay}
    />
  </Stack>
}

export default PriceStackPriceWithLoyaltyLeadWithRegularPrice
